import { useCallback, useEffect, useState } from 'react';
import { CustomProvider, Drawer, Sidenav, Navbar, Nav, Badge } from 'rsuite';
import { FaBell, FaExternalLinkAlt, FaWhatsapp, FaStore } from 'react-icons/fa';
import KeyIcon from '@rsuite/icons/legacy/Key';
import DashboardIcon from '@rsuite/icons/legacy/Dashboard';
import TextImageIcon from '@rsuite/icons/TextImage';
import CreativeIcon from '@rsuite/icons/Creative';
import MagicIcon from '@rsuite/icons/legacy/Magic';
import GearIcon from '@rsuite/icons/Gear';
import GearCircleIcon from '@rsuite/icons/legacy/GearCircle';
import CouponIcon from '@rsuite/icons/Coupon';
import SearchIcon from '@rsuite/icons/Search';
import Exit from '@rsuite/icons/Exit';
import logo from '../../assets/logo_gestor_sem_fundo.png';
import axios from 'axios';
import 'rsuite/dist/rsuite.min.css';
import { useAuth } from '../../hooks/auth';
import { usePermission } from '../../hooks/usePermission';
import { TbRobot } from 'react-icons/tb';
import { useCustomTheme } from '../../hooks/useCustomTheme';
import { CustomNavItem } from '../CustomNav/CustomNavItem';
import { CustomNavMenu } from '../CustomNav/CustomNavMenu';
import { useHistory, useLocation } from 'react-router-dom';
import { getConpanyService } from '../../services/company/getCompany.service';
import { toastSuccess, toastError } from '../../toasts';
import {
  MenucheffId,
  SoonBadge,
  styles,
  DrawerHeader,
  DrawerAvatar,
  DrawerGreeting,
  DrawerGreetingName,
  DrawerGreetingSub,
  SectionLabel,
  NavItem,
} from './styles';
import { temAcessoApiOficial } from '../../config/apiOficialWhatsapp';
import ChangePassword from '../ChangePassword';
import { CustomToggle } from '../CustomToggle';
import api from '../../services/api';
import { useConfig } from '../../hooks/config';
import { useWarnings } from '../../hooks/useWarnings';
import GlobalWarningModal from '../GlobalWarningModal';
import './styles.css';

const Menu = () => {
  const { config } = useConfig();
  const { unreadCount } = useWarnings();
  const [open, setOpen] = useState(false);
  const [openStore, setOpenStore] = useState(false);
  const [placement, setPlacement] = useState();
  const [company, setCompany] = useState(null);
  const { signOut, user, id_empresa } = useAuth();
  const { can, canAny } = usePermission();
  const [changePass, setChangePass] = useState(false);
  const apiOficialLiberada = temAcessoApiOficial(id_empresa);

  const location = useLocation();
  const path = location.pathname;

  const history = useHistory();

  const { theme } = useCustomTheme();

  const getInitials = (name = '') => {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };

  const handleOpen = (key) => {
    setOpen(true);
    setPlacement(key);
  };

  const baixarQRCode = async () => {
    const response = await axios.post(
      'https://cardapio.menucheff.com/api/qrcodesmenucheff2/',
      {
        contrato: id_empresa,
      },
      {
        headers: {
          contrato: id_empresa,
          secret: '2348ffc3969e288be2e52c079e44b715',
        },
      },
    );
    const link = document.createElement('a');
    link.download = 'Imagem';
    link.href = response.data.url;
    link.click();
  };

  function copiarCodigoMenucheff2() {
    if (company) {
      navigator.clipboard.writeText(company.Id);
      toastSuccess('Id copiado com sucesso');
    } else {
      toastError('Empresa não está cadastrada');
    }
  }

  const handleOpenOrClose = useCallback(() => {
    setOpenStore(!openStore);
    api
      .patch(`configuracao/store/${id_empresa}`, { status: !openStore })
      .then(() => {
        toastSuccess('Loja atualizada com sucesso');
      })
      .catch(() => {
        toastError('Erro ao atualizar loja');
      });
  }, [id_empresa, openStore]);

  const handleNavigate = (path = '') => {
    history.push(path);
    setOpen(false);
  };

  const redirectToApp = () => {
    window.open(process.env.REACT_APP_URL + company?.NrContrato, '_blank');
  };

  const handleOpenAvisos = () => {
    handleNavigate('/g_avisos');
  };

  const handleWhatsAppRedirect = () => {
    const mensagem =
      'Olá! Tenho interesse em contratar a API Oficial do WhatsApp para o meu sistema.';
    const linkWhatsApp = `https://wa.me/556391000057?text=${encodeURIComponent(mensagem)}`;
    window.open(linkWhatsApp, '_blank');
  };

  useEffect(() => {
    getConpanyService(id_empresa).then((data) => {
      setCompany(data);
    });
  }, [id_empresa]);

  useEffect(() => {
    setOpenStore(config?.IsOpen);
  }, [config]);

  const hasGestaoLoja =
    can('cardapio') ||
    canAny('configuracoes', 'entregadores', 'usuarios', 'empresa', 'banners') ||
    can('chatbot') ||
    canAny('cupons', 'fidelidade', 'promocoes');
  const hasRelatorios = canAny('agendamento', 'relatorios', 'fidelidade');

  return (
    <>
      {user && !path.includes('imprimir') && (
        <CustomProvider theme="light">
          <Navbar
            className="menu-navbar"
            style={{
              background:
                'linear-gradient(135deg, #0a1440 0%, #142a6e 55%, #1f3d8f 100%)',
              color: '#fff',
              position: 'sticky',
              top: 0,
              zIndex: 999,
              boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            }}
          >
            <Nav>
              <Nav.Item
                className="navbar-menu-item"
                onClick={() => handleOpen('left')}
              >
                <span className={`navbar-hamburger${open ? ' is-open' : ''}`}>
                  <span className="navbar-hamburger-bar" />
                  <span className="navbar-hamburger-bar" />
                  <span className="navbar-hamburger-bar" />
                </span>
              </Nav.Item>
            </Nav>
            <Navbar.Brand
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingLeft: '0',
                cursor: 'pointer',
              }}
              onClick={() => (window.location.href = '/g_pedidos')}
            >
              <img src={logo} height="45" alt="" loading="lazy" />
            </Navbar.Brand>
            <Nav>
              <Nav.Item
                className="navbar-item-custom navbar-company-item"
                onClick={() => handleNavigate('/g_empresa')}
              >
                <span className="navbar-icon-chip">
                  <FaStore size={14} />
                </span>
                <span className="navbar-item-labels">
                  <span className="navbar-item-labelMain">
                    {company?.NomeFantasia}
                  </span>
                  <span className="navbar-item-labelSub">
                    Contrato Nº {company?.NrContrato}
                  </span>
                </span>
              </Nav.Item>
              <Nav.Item
                className="navbar-item-custom navbar-action-item"
                onClick={handleWhatsAppRedirect}
              >
                <span className="navbar-icon-chip navbar-icon-chip--whatsapp">
                  <FaWhatsapp size={15} />
                </span>
                <span className="navbar-item-labelMain">
                  API Oficial WhatsApp
                </span>
              </Nav.Item>
              <Nav.Item
                className="navbar-item-custom navbar-action-item"
                onClick={() => redirectToApp()}
              >
                <span className="navbar-icon-chip">
                  <FaExternalLinkAlt size={13} />
                </span>
                <span className="navbar-item-labelMain">Acessar App</span>
              </Nav.Item>
              {can('configuracoes') && (
                <NavItem>
                  <CustomToggle
                    id="isOpen"
                    checkedChildren="Loja Aberta"
                    unCheckedChildren="Loja Fechada"
                    size="lg"
                    checked={openStore}
                    onChange={handleOpenOrClose}
                  />
                </NavItem>
              )}
            </Nav>
            <Nav pullRight>
              <Nav.Item className="navbar-bell-item" onClick={handleOpenAvisos}>
                <span className="navbar-icon-chip navbar-icon-chip--bell">
                  {unreadCount > 0 ? (
                    <Badge content={unreadCount} color="red">
                      <span className="navbar-bell-icon">
                        <FaBell size={15} />
                      </span>
                    </Badge>
                  ) : (
                    <span className="navbar-bell-icon">
                      <FaBell size={15} />
                    </span>
                  )}
                </span>
              </Nav.Item>
              <Nav.Menu
                toggleClassName="navbar-user-menu"
                title={
                  <span className="navbar-user-title">
                    <span className="navbar-avatar-chip">
                      {getInitials(user?.Nome)}
                    </span>
                    <span className="navbar-user-name">
                      {user.Nome?.split(' ')[0].toUpperCase()}
                    </span>
                  </span>
                }
                style={{ padding: '0px 10px' }}
              >
                <Nav.Item
                  eventKey="1"
                  icon={<KeyIcon />}
                  onClick={() => setChangePass(true)}
                >
                  Trocar Senha
                </Nav.Item>
                <Nav.Item
                  eventKey="2"
                  icon={<Exit />}
                  onClick={() => {
                    signOut();
                    handleNavigate('/');
                  }}
                >
                  Sair
                </Nav.Item>
              </Nav.Menu>
            </Nav>
          </Navbar>
          <div style={{ display: 'flex' }}>
            <div style={styles.content}>
              <div id="nav" style={styles.navbar}>
                <Drawer
                  size="xs"
                  placement={placement}
                  open={open}
                  onClose={() => setOpen(false)}
                >
                  <Drawer.Body
                    style={{
                      padding: 0,
                      backgroundColor: theme.colors.backgroundSecondary,
                    }}
                  >
                    <DrawerHeader>
                      <DrawerAvatar>{getInitials(user?.Nome)}</DrawerAvatar>
                      <DrawerGreeting>
                        <DrawerGreetingName>
                          Olá, {user?.Nome?.split(' ')[0]}!
                        </DrawerGreetingName>
                        <DrawerGreetingSub>
                          {company?.NomeFantasia ||
                            'Gerencie sua loja por aqui'}
                        </DrawerGreetingSub>
                      </DrawerGreeting>
                    </DrawerHeader>
                    <Sidenav>
                      <Sidenav.Body>
                        <Nav>
                          {can('pedidos') && (
                            <>
                              <SectionLabel>Principal</SectionLabel>
                              <CustomNavItem
                                icon={<DashboardIcon />}
                                subtitle="Acompanhe os pedidos em tempo real"
                                style={{
                                  backgroundColor:
                                    theme.colors.backgroundSecondary,
                                  color: theme.colors.text,
                                }}
                                onClick={() => handleNavigate('/g_pedidos')}
                              >
                                Dashboard de Pedidos
                              </CustomNavItem>
                            </>
                          )}
                          {hasGestaoLoja && (
                            <SectionLabel>Gestão da loja</SectionLabel>
                          )}
                          {can('cardapio') && (
                            <CustomNavMenu
                              title="Cardápio"
                              icon={<MagicIcon />}
                              subtitle="Produtos, grupos e montagem de pratos"
                            >
                              <CustomNavItem
                                onClick={() => handleNavigate('/g_produtos')}
                                style={{
                                  backgroundColor:
                                    theme.colors.backgroundSecondary,
                                  color: theme.colors.text,
                                }}
                              >
                                Produtos
                              </CustomNavItem>
                              <CustomNavItem
                                onClick={() =>
                                  handleNavigate('/g_grupoproduto')
                                }
                                style={{
                                  backgroundColor:
                                    theme.colors.backgroundSecondary,
                                  color: theme.colors.text,
                                }}
                              >
                                Grupos
                              </CustomNavItem>
                              <CustomNavItem
                                onClick={() => handleNavigate('/g_montagem')}
                                style={{
                                  backgroundColor:
                                    theme.colors.backgroundSecondary,
                                  color: theme.colors.text,
                                }}
                              >
                                Montagem de Pratos
                              </CustomNavItem>
                              <CustomNavItem
                                onClick={() =>
                                  handleNavigate('/g_tamanhos_pizza')
                                }
                                style={{
                                  backgroundColor:
                                    theme.colors.backgroundSecondary,
                                  color: theme.colors.text,
                                }}
                              >
                                Tamanhos Pizzas
                              </CustomNavItem>
                            </CustomNavMenu>
                          )}
                          {canAny(
                            'configuracoes',
                            'entregadores',
                            'usuarios',
                            'empresa',
                            'banners',
                          ) && (
                            <CustomNavMenu
                              title="Configurações da loja"
                              icon={<GearCircleIcon />}
                              subtitle="Horários, pagamentos, entregadores e mais"
                            >
                              {can('configuracoes') && (
                                <CustomNavItem
                                  onClick={() => handleNavigate('/g_horarios')}
                                  style={{
                                    backgroundColor:
                                      theme.colors.backgroundSecondary,
                                    color: theme.colors.text,
                                  }}
                                >
                                  Horarios de Funcionamento
                                </CustomNavItem>
                              )}
                              {can('configuracoes') && (
                                <CustomNavItem
                                  onClick={() => handleNavigate('/g_feriados')}
                                  style={{
                                    backgroundColor:
                                      theme.colors.backgroundSecondary,
                                    color: theme.colors.text,
                                  }}
                                >
                                  Feriados e Pausas
                                </CustomNavItem>
                              )}
                              {can('configuracoes') && (
                                <CustomNavItem
                                  onClick={() =>
                                    handleNavigate('/g_pagamentos')
                                  }
                                  style={{
                                    backgroundColor:
                                      theme.colors.backgroundSecondary,
                                    color: theme.colors.text,
                                  }}
                                >
                                  Formas de Pagamento
                                </CustomNavItem>
                              )}
                              {can('configuracoes') && (
                                <CustomNavItem
                                  onClick={() => handleNavigate('/g_bairro')}
                                  style={{
                                    backgroundColor:
                                      theme.colors.backgroundSecondary,
                                    color: theme.colors.text,
                                  }}
                                >
                                  Bairros e Taxas de Entrega
                                </CustomNavItem>
                              )}
                              {can('entregadores') && (
                                <CustomNavItem
                                  onClick={() =>
                                    handleNavigate('/g_entregadores')
                                  }
                                  style={{
                                    backgroundColor:
                                      theme.colors.backgroundSecondary,
                                    color: theme.colors.text,
                                  }}
                                >
                                  Entregadores
                                </CustomNavItem>
                              )}
                              {can('configuracoes') && (
                                <CustomNavItem
                                  onClick={() => handleNavigate('/g_regioes')}
                                  style={{
                                    backgroundColor:
                                      theme.colors.backgroundSecondary,
                                    color: theme.colors.text,
                                  }}
                                >
                                  Regiões
                                </CustomNavItem>
                              )}
                              {can('usuarios') && (
                                <CustomNavItem
                                  onClick={() =>
                                    handleNavigate('/g_grupos_acesso')
                                  }
                                  style={{
                                    backgroundColor:
                                      theme.colors.backgroundSecondary,
                                    color: theme.colors.text,
                                  }}
                                >
                                  Grupos de Acesso de Usuários
                                </CustomNavItem>
                              )}
                              {can('usuarios') && (
                                <CustomNavItem
                                  onClick={() => handleNavigate('/g_usuarios')}
                                  style={{
                                    backgroundColor:
                                      theme.colors.backgroundSecondary,
                                    color: theme.colors.text,
                                  }}
                                >
                                  Usuários
                                </CustomNavItem>
                              )}
                              {can('empresa') && (
                                <CustomNavItem
                                  onClick={() => handleNavigate('/g_contas')}
                                  style={{
                                    backgroundColor:
                                      theme.colors.backgroundSecondary,
                                    color: theme.colors.text,
                                  }}
                                >
                                  Contas bancárias
                                </CustomNavItem>
                              )}
                              {can('empresa') && (
                                <CustomNavItem
                                  onClick={() =>
                                    handleNavigate('/g_cartaovisita')
                                  }
                                  style={{
                                    backgroundColor:
                                      theme.colors.backgroundSecondary,
                                    color: theme.colors.text,
                                  }}
                                >
                                  Cartão visita
                                </CustomNavItem>
                              )}
                              {can('banners') && (
                                <CustomNavItem
                                  onClick={() => handleNavigate('/g_banners')}
                                  style={{
                                    backgroundColor:
                                      theme.colors.backgroundSecondary,
                                    color: theme.colors.text,
                                  }}
                                >
                                  Banners
                                </CustomNavItem>
                              )}
                              {can('empresa') && (
                                <CustomNavItem
                                  onClick={() => baixarQRCode()}
                                  style={{
                                    backgroundColor:
                                      theme.colors.backgroundSecondary,
                                    color: theme.colors.text,
                                  }}
                                >
                                  Download do QRCode
                                </CustomNavItem>
                              )}
                              {can('empresa') && company && (
                                <CustomNavItem
                                  onClick={() => copiarCodigoMenucheff2()}
                                  style={{
                                    backgroundColor:
                                      theme.colors.backgroundSecondary,
                                    color: theme.colors.text,
                                  }}
                                >
                                  Copiar ID Menucheff:{' '}
                                  <MenucheffId>{company.Id}</MenucheffId>
                                </CustomNavItem>
                              )}
                            </CustomNavMenu>
                          )}
                          {can('chatbot') && (
                            <CustomNavMenu
                              title="Robô"
                              icon={<TbRobot size={16} />}
                              subtitle="Automação de mensagens no WhatsApp"
                            >
                              <CustomNavItem
                                onClick={() =>
                                  handleNavigate(
                                    '/chatbot/templates-de-mensagens',
                                  )
                                }
                              >
                                Templates de mensagens
                              </CustomNavItem>
                              {apiOficialLiberada ? (
                                <CustomNavItem
                                  onClick={() =>
                                    handleNavigate('/chatbot/conexoes')
                                  }
                                >
                                  Conexões
                                </CustomNavItem>
                              ) : (
                                <CustomNavItem disabled title="Em breve">
                                  Conexões <SoonBadge>Em breve</SoonBadge>
                                </CustomNavItem>
                              )}
                            </CustomNavMenu>
                          )}
                          {canAny('cupons', 'fidelidade', 'promocoes') && (
                            <CustomNavMenu
                              title="Promocional"
                              icon={<CouponIcon />}
                              subtitle="Cupons, fidelidade e promoções"
                            >
                              {can('cupons') && (
                                <CustomNavItem
                                  onClick={() => handleNavigate('/g_cupons')}
                                >
                                  Cupom de Desconto
                                </CustomNavItem>
                              )}
                              {can('fidelidade') && (
                                <CustomNavItem
                                  onClick={() =>
                                    handleNavigate('/g_fidelidade')
                                  }
                                >
                                  Fidelidade
                                </CustomNavItem>
                              )}
                              {can('promocoes') && (
                                <CustomNavItem
                                  onClick={() => handleNavigate('/g_promocao')}
                                >
                                  Promoção
                                </CustomNavItem>
                              )}
                            </CustomNavMenu>
                          )}
                          {hasRelatorios && (
                            <SectionLabel>Consultas e relatórios</SectionLabel>
                          )}
                          {canAny(
                            'agendamento',
                            'relatorios',
                            'fidelidade',
                          ) && (
                            <CustomNavMenu
                              title="Consultas e Relatorios"
                              icon={<SearchIcon />}
                              subtitle="Pedidos, vendas e avaliações"
                            >
                              {can('agendamento') && (
                                <CustomNavItem
                                  onClick={() =>
                                    handleNavigate('/g_agendamento')
                                  }
                                >
                                  Consultar Agendamentos
                                </CustomNavItem>
                              )}
                              {can('relatorios') && (
                                <CustomNavItem
                                  onClick={() =>
                                    handleNavigate('/g_consultarpedidos')
                                  }
                                >
                                  Consultar Pedidos
                                </CustomNavItem>
                              )}
                              {can('relatorios') && (
                                <CustomNavItem
                                  onClick={() =>
                                    handleNavigate('/g_consultarprodutos')
                                  }
                                >
                                  Consultar Produtos
                                </CustomNavItem>
                              )}
                              {can('relatorios') && (
                                <CustomNavItem
                                  onClick={() =>
                                    handleNavigate('/g_vendasPorFormaPagamento')
                                  }
                                >
                                  Vendas por Forma de Pagamento
                                </CustomNavItem>
                              )}
                              {can('relatorios') && (
                                <CustomNavItem
                                  onClick={() =>
                                    handleNavigate('/g_vendasPorPeriodoHorario')
                                  }
                                >
                                  Vendas por Período e Horário
                                </CustomNavItem>
                              )}
                              {can('fidelidade') && (
                                <CustomNavItem
                                  onClick={() => handleNavigate('/g_clientes')}
                                >
                                  Clientes Fidelizados
                                </CustomNavItem>
                              )}
                              {can('relatorios') && (
                                <CustomNavItem
                                  onClick={() =>
                                    handleNavigate('/g_relatorio_vendas')
                                  }
                                >
                                  Relatório de Vendas
                                </CustomNavItem>
                              )}
                              {can('relatorios') && (
                                <CustomNavItem
                                  onClick={() =>
                                    handleNavigate(
                                      '/g_relatorio_cupons_utilizados',
                                    )
                                  }
                                >
                                  Relatório de Cupons Utilizados
                                </CustomNavItem>
                              )}
                              {can('relatorios') && (
                                <CustomNavItem
                                  onClick={() =>
                                    handleNavigate(
                                      '/g_relatorio_vendas_entregador',
                                    )
                                  }
                                >
                                  Relatório de Vendas por Entregador
                                </CustomNavItem>
                              )}
                              {can('relatorios') && (
                                <CustomNavItem
                                  onClick={() =>
                                    handleNavigate('/g_avaliacoes')
                                  }
                                >
                                  Avaliações dos Clientes
                                </CustomNavItem>
                              )}
                            </CustomNavMenu>
                          )}
                          <SectionLabel>Outros</SectionLabel>
                          {can('configuracoes') && (
                            <CustomNavItem
                              icon={<GearIcon spin />}
                              subtitle="Cores, banners e identidade visual"
                              onClick={() => handleNavigate('/g_configuracao')}
                            >
                              Personalizar Aplicativo
                            </CustomNavItem>
                          )}
                          <CustomNavItem
                            icon={<CreativeIcon />}
                            subtitle="Conheça outras ferramentas MenuCheff"
                            style={{
                              backgroundColor: theme.colors.backgroundSecondary,
                              color: theme.colors.text,
                            }}
                            onClick={() =>
                              handleNavigate('/g_servicossolucoes')
                            }
                          >
                            Serviços e Soluções
                          </CustomNavItem>
                          {can('empresa') && (
                            <CustomNavItem
                              icon={<TextImageIcon />}
                              subtitle="Informações cadastrais do seu negócio"
                              style={{
                                backgroundColor:
                                  theme.colors.backgroundSecondary,
                                color: theme.colors.text,
                              }}
                              onClick={() => handleNavigate('/g_empresa')}
                            >
                              Dados da Empresa
                            </CustomNavItem>
                          )}
                        </Nav>
                      </Sidenav.Body>
                    </Sidenav>
                  </Drawer.Body>
                </Drawer>
              </div>
            </div>
          </div>
          {changePass && (
            <ChangePassword
              open={changePass}
              onClose={() => setChangePass(false)}
            />
          )}
          <GlobalWarningModal />
        </CustomProvider>
      )}
    </>
  );
};

export default Menu;
